import { render, staticRenderFns } from "./GlobalMetrics.vue?vue&type=template&id=71cf101a&scoped=true&"
import script from "./GlobalMetrics.vue?vue&type=script&lang=js&"
export * from "./GlobalMetrics.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMetrics.vue?vue&type=style&index=0&id=71cf101a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cf101a",
  null
  
)

export default component.exports